import { TransientAccessCredEventNames } from '../../prevent_transient_access/constants/transient_access_cred_constants';
import { PreventTransientAccessQuery } from '../../prevent_transient_access/queries/prevent_transient_access_query';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { SchedulerModel } from '../../views/course_scheduler/models/scheduler_model';
import * as _4 from 'lodash4';
import { DropCourseFacade } from '../../views/registration/facades/drop_course_facade';
import { IMenuAction, ISection } from '../../interfaces/scheduler_interfaces';
import { SectionTileMenuEnum } from '../../views/course_scheduler/types/section_tile_menu_enum';
import { ScheduledSectionServant } from '../../views/course_scheduler/servants/scheduled_section_servant';
import { ICommand } from 'core-ts-types';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import { SelectedSectionActionsFacade } from '../../views/course_scheduler/facades/selected_section_actions_facade';
import { ScheduledSectionRequestStateCommand } from '../../request_state/commands/scheduled_section_request_state_command';

export class WithdrawModalController {
  private opened: boolean = true;
  private section: ISection;
  private sectionId: number = 0;
  private withdrawConfirmationText: string = '';
  private withdrawBound = this.withdraw.bind(this);
  private closeDialogBound = this.closeDialog.bind(this);

  constructor(
    private $state: any,
    private ngSchedulerModel: SchedulerModel,
    private ngDropCourseFacade: DropCourseFacade,
    private saveTermPinCommand: ICommand,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngPreventTransientAccessQuery: PreventTransientAccessQuery,
    private ngComponentCommunicatorService: CommunicatorService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngSelectedSectionActionsFacade: SelectedSectionActionsFacade,
    private scheduledSectionRequestStateCommand: ScheduledSectionRequestStateCommand
  ) {
    this.releaseSubscribedEvents();
    this.ngComponentCommunicatorService.subscribe(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.closeDialogBound
    );
    this.ngComponentCommunicatorService.subscribe(TransientAccessCredEventNames.NEW_CRED_SAVED, this.withdrawBound);
  }

  releaseSubscribedEvents() {
    this.ngComponentCommunicatorService.release(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.closeDialogBound
    );
    this.ngComponentCommunicatorService.release(TransientAccessCredEventNames.NEW_CRED_SAVED, this.withdrawBound);
  }

  closeDialog() {
    this.opened = false;
    this.scheduledSectionRequestStateCommand([this.sectionId], false);
    this.releaseSubscribedEvents();
    this.$state.__goToPrevious__();
  }
  $onInit() {
    this.init();
  }
  init() {
    this.withdrawConfirmationText = this.ngSelectedSectionActionsFacade.getWithdrawText();
    this.sectionId = parseInt(this.$stateParams.sectionId, 10);
    this.section = _4.find(this.ngSectionsDatasource.metasource().derived(), { id: this.sectionId });
    this.scheduledSectionRequestStateCommand([this.sectionId], true);
  }

  withdraw() {
    if (this.ngPreventTransientAccessQuery.result.redirectToAuthWorkflow) {
      return this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS);
    }

    const action = {
      id: SectionTileMenuEnum.WITHDRAW,
      text: ''
    };

    // Todo added section pin
    const sectionPins = {};

    this.saveTermPinCommand(this.$stateParams.termId).then(() => {
      this.ngDropCourseFacade.dropCourseAndCoreqs(
        this.section,
        action,
        sectionPins,
        this.ngPreventTransientAccessQuery.result.output
      );
    });

    return this.closeDialog();
  }
}

angular.module('capability-ng-scheduler').component('withdrawModal', {
  controller: WithdrawModalController,
  templateUrl: 'capability-ng-scheduler/src/components/withdraw_modal/withdraw_modal.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/withdraw_modal/withdraw_modal.ts